module.exports = "/assets/27e79136cd8e95a339f51c3c1fabfe39.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PD.png
// module id = 1712
// module chunks = 0